import React from 'react';
import './LandingPage.css';

const LandingPageRelatie = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      {/* Navigation */}
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo" onClick={scrollToTop}>
            <span className="logo-pabb">PABB</span>
            <span className="logo-divider">|</span>
            <span className="logo-product">RelatieScan</span>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">RelatieScan voor Relatietherapie</h1>
            <p className="hero-subtitle">
              Professioneel assessment tool voor relatietherapeuten, gebaseerd op bewezen methodiek
            </p>
            
            <div className="hero-benefits">
              <div className="benefit-item">
                <span className="benefit-icon">⏱️</span>
                <span className="benefit-text">Bespaar 30-45 min intake tijd</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">✓</span>
                <span className="benefit-text">Stellen komen beter voorbereid</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">🎯</span>
                <span className="benefit-text">Direct inzicht in kernproblemen</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lencioni Model Section */}
      <section className="model-section">
        <div className="container">
          <h2 className="section-title">Gebaseerd op Lencioni's Model</h2>
          <p className="section-intro">
            De RelatieScan is gebaseerd op Patrick Lencioni's piramide model. Dit model identificeert 5 niveaus die de kwaliteit van samenwerking bepalen.
          </p>
          
          <div className="pyramid">
            <div className="pyramid-level level-5">
              <span className="level-number">5</span>
              <span className="level-name">Resultaten</span>
            </div>
            <div className="pyramid-level level-4">
              <span className="level-number">4</span>
              <span className="level-name">Verantwoordelijkheid</span>
            </div>
            <div className="pyramid-level level-3">
              <span className="level-number">3</span>
              <span className="level-name">Commitment</span>
            </div>
            <div className="pyramid-level level-2">
              <span className="level-number">2</span>
              <span className="level-name">Constructief Conflict</span>
            </div>
            <div className="pyramid-level level-1">
              <span className="level-number">1</span>
              <span className="level-name">Vertrouwen</span>
            </div>
          </div>
        </div>
      </section>

      {/* 5 Levels Explained */}
      <section className="levels-section">
        <div className="container">
          <h2 className="section-title">De 5 Niveaus Uitgelegd</h2>
          
          <div className="levels-grid">
            <div className="level-card card-1">
              <div className="level-header">
                <span className="level-emoji">🤝</span>
                <h3 className="level-title">1. Vertrouwen</h3>
              </div>
              <p className="level-description">
                Het fundament. Zonder vertrouwen durven partners niet kwetsbaar te zijn en blijven echte gevoelens verborgen.
              </p>
            </div>

            <div className="level-card card-2">
              <div className="level-header">
                <span className="level-emoji">💬</span>
                <h3 className="level-title">2. Constructief Conflict</h3>
              </div>
              <p className="level-description">
                Kunnen partners op een gezonde manier meningsverschillen bespreken zonder te escaleren of te vermijden?
              </p>
            </div>

            <div className="level-card card-3">
              <div className="level-header">
                <span className="level-emoji">✍️</span>
                <h3 className="level-title">3. Commitment</h3>
              </div>
              <p className="level-description">
                Kunnen partners besluiten nemen en zich daar ook aan houden, zelfs als ze het er niet volledig mee eens zijn?
              </p>
            </div>

            <div className="level-card card-4">
              <div className="level-header">
                <span className="level-emoji">⚖️</span>
                <h3 className="level-title">4. Verantwoordelijkheid</h3>
              </div>
              <p className="level-description">
                Durven partners elkaar aan te spreken op gedrag dat niet overeenkomt met gemaakte afspraken?
              </p>
            </div>

            <div className="level-card card-5">
              <div className="level-header">
                <span className="level-emoji">🎯</span>
                <h3 className="level-title">5. Resultaten</h3>
              </div>
              <p className="level-description">
                Werken partners samen aan gezamenlijke doelen of zijn ze vooral bezig met individuele behoeften?
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How it Works */}
      <section className="how-section">
        <div className="container">
          <h2 className="section-title">Hoe werkt het?</h2>
          
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3 className="step-title">Beide partners vullen de scan online in</h3>
              <p className="step-description">Duur: 15-20 minuten per persoon</p>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <h3 className="step-title">Jij ontvangt een gestructureerd rapport</h3>
              <p className="step-description">Direct inzicht in sterke en zwakke punten</p>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <h3 className="step-title">Intake gesprek is gerichter en efficiënter</h3>
              <p className="step-description">Focus direct op de kernproblemen</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pilot CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Interesse in een pilot?</h2>
            <p className="cta-description">
              We zijn op zoek naar relatietherapeuten die de RelatieScan willen testen in hun praktijk.
            </p>
            <p className="cta-subdescription">
              Neem contact op voor meer informatie over de pilot en mogelijkheden.
            </p>
            <a href="mailto:diederik@tractum.nl" className="cta-button">
              Contact opnemen
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p className="footer-text">© 2025 PABB VOF - RelatieScan</p>
          <p className="footer-credit">Gebaseerd op Patrick Lencioni's methodiek</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPageRelatie;